
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./PlaceholderView',
	'text!./ShortcutPlaceholder.html',
	'../../../lib/@waca/core-client/js/core-client/utils/Utils',
	'@ba/ba-graphics/dist/icons-js/text--creation_32',
	'@ba/ba-graphics/dist/icons-js/image_32',
	'../../../app/nls/StringResources',
	'jquery'
], function(BaseClass, Template, Utils, textIcon, imageIcon, stringResources, $) {
	var ShortcutPlaceholderView = null;
	const MIN_HEIGHT = 114;
	const MIN_WIDTH = 256;

	ShortcutPlaceholderView = BaseClass.extend({
		templateString: Template,

		init: function(options = {}) {
			ShortcutPlaceholderView.inherited('init', this, arguments);

			this.onVisualizationSelected = options.onVisualizationSelected;
			this.onTextSelected = options.onTextSelected;
			this.onImageSelected = options.onImageSelected;

			this.activeButtons = [];
		},

		render: function() {
			this.$el.append(this.dotTemplate({
				widgetHeader: stringResources.get('multipurposeHeader'),
				placeholderText: stringResources.get('multipurposePlaceholderText'),
				visLabel: stringResources.get('live_label'),
				textLabel: stringResources.get('textWidgetLabel'),
				imageLabel: stringResources.get('imageWidgetLabel')
			}));
			this._hideShowText();
			var $visualizationBtn = this.$el.find('.visualization');
			var $textBtn = this.$el.find('.text');
			var $imageBtn = this.$el.find('.image');

			Utils.setIcon($visualizationBtn, 'common-visualization');
			Utils.setIcon($textBtn, textIcon.default.id);
			Utils.setIcon($imageBtn, imageIcon.default.id);

			this._eventHandlers([
				[ $visualizationBtn, this.onVisualizationSelected ],
				[ $textBtn, this.onTextSelected ],
				[ $imageBtn, this.onImageSelected ]
			]);
		},
		_isCompact: function(){
			var maxWidth = 110;
			return this.$el.width() < maxWidth;
		},

		_shouldHideText() {
			const containerWidth = this.$el.width();
			const containerHeight = this.$el.height();
			return containerWidth < MIN_WIDTH || containerHeight < MIN_HEIGHT;
		},

		_hideShowText() {
			const hidePlaceholderText = this._shouldHideText();
			this.$el.find('.multipurposeWidgetHeader').toggleClass('hide', hidePlaceholderText);
			this.$el.find('.multipurposeWidgetPlaceholderText').toggleClass('hide', hidePlaceholderText);
		},

		resize: function() {
			this.$el.find('.shortcut').toggleClass('compact', this._isCompact());
			this._hideShowText();
		},

		_onKeyDown: function(handler, e) {
			if(e.which === 32 || e.which === 13) { // enter, space
				e.preventDefault();
				handler();
			}
		},

		destroy: function () {
			this.activeButtons.forEach(button => button.off());
			if (this.eventNamespace) {
				$(document).off(this.eventNamespace);
			}
			ShortcutPlaceholderView.inherited('destroy', this, arguments);
		},

		_eventHandlers: function(buttons) {
			this.eventNamespace = 'mouseup.' + this.viewId;

			buttons.forEach((pair) => {
				const button = pair[0];
				const handler = pair[1].bind(this);

				button.on('keydown', this._onKeyDown.bind(this, handler));
				button.on('primaryaction', handler);
				button.on('mouseup', () => this.activeHandler = null);
				button.on('mousedown', e => {
					this.time = e.timeStamp;
					this.activeHandler = handler;
				});


				this.activeButtons.push(button);
			});

			$(document).on(this.eventNamespace, e => {
				if (this.activeHandler && (e.timeStamp - this.time) <= 300) {
					this.activeHandler();
				}
			});
		}
	});

	return ShortcutPlaceholderView;
});
